import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ContentUtil } from '../../../utils/content/content.util';
import { ClientSegmentFacadeService } from 'src/app/services/client-segment-observer/client-segment.service';
import { ClientSegmentContentDTO } from 'src/common/dtos/client-segment.dto';
import { Subject, takeUntil } from 'rxjs';
import { TileComponent } from '../tile.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'zci-rm-info-tile',
    templateUrl: './rm-info-tile.component.html',
    styleUrls: ['./rm-info-tile.component.scss'],
    imports: [
        TileComponent,
        NgIf
    ]
})
export class RmInfoTileComponent implements OnInit, OnDestroy {
    private readonly clientSegmentFacadeService = inject(ClientSegmentFacadeService);

    content = ContentUtil.grantorFragmentContent;
    rmContactInfo = this.content?.remove_account_access?.cnfoWealthManagementSupportTeam;

    supportTeam: string;
    phoneNumber: string;
    email: string;
    supportHours: string;
    private destroy$ = new Subject<void>();

    ngOnInit(): void {
        this.clientSegmentFacadeService.clientSegmentContent$
            .pipe(takeUntil(this.destroy$))
            .subscribe((content: ClientSegmentContentDTO) => {
                this.supportTeam = this.rmContactInfo.zciWmSupportNameLabel.replace('${supportTeam}', content?.supportTeam)
                this.phoneNumber = this.rmContactInfo.zciWmSupportPhoneLabel.replace('${phoneNumber}', content?.phoneNumber)
                this.email = this.rmContactInfo.zciWmSupportEmailLabel.replace('${supportEmail}', content?.supportEmail)
                this.supportHours = this.rmContactInfo.zciWmSupportHoursLabel.replace('${supportHours}', content?.supportHours)
            });
    }

    callCRM(): void {
        window.location.href = `tel:{{ this.phoneNumber }}`;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
